import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../service/api_service';
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { ColumnApi, GridApi } from 'ag-grid-community';
import { Subscription } from 'rxjs'; 
@Component({
    selector: 'app-loggedunloggedreport',
    template: require('./loggedunloggedreport.component.html'),
    styles: []
})
export class LoggeUunoggedReportComponent implements OnInit {

    expDetails: any;
    private columnDefs;
    private EmpcolumnDefs;
    private EmpcolumnDefsExport;
    private rowData;
    private rowHeight;
    api: any;
    busy: Subscription;
    api1: GridApi;
    api2: GridApi;
    columnApi: any;
    columnApi1: ColumnApi;
    columnApi2: ColumnApi;
    defaultColDefine;
    currentMonth: any;
    staffTypes: any;
    staff: any;
    designation: any;
    currentDate: any;
    SearchModel: any;
    EmpDetailsList: any;
    EmpCountDetails: any;
    EmpData: any;
    ManagerList: any;
    status: any;
    token:any;

    Search_Form = new FormGroup({
        SearchDate: new FormControl('', [Validators.required]),
        SearchTime: new FormControl('', [Validators.required])
    });

    static parameters = [ApiService, Router, HttpClient]
    constructor(private apiService: ApiService, private router: Router, private http: HttpClient) {
        this.defaultColDefine = { resizable: true };
        this.rowHeight = 50;
    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.status = "-1";
        this.SearchModel = { ManagerID: 0, ClientID: 0 };
        var date = new Date();
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        var Date1 = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var Time = (hours < 10 ? "0" + hours : hours) + ":" + (minutes < 10 ? "0" + minutes : minutes);
        this.Search_Form.controls['SearchDate'].setValue(Date1);
        this.Search_Form.controls['SearchTime'].setValue(Time);

        this.columnDefs = [
            { headerName: 'S.No.', field: 'SNo', width: 80 },
            {
                headerName: 'Log Status', field: 'LogStatus'
                , cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = `<a href="" class="status-report" data-toggle="modal" data-target="#leaveStatusReport" id="` + params.data.LogStatus + `">` + params.data.LogStatus + `</a>`;
                    return eDiv;
                }
            },
            { headerName: 'No of Log', field: "LogCount" },
            // { headerName: 'Manager', field: 'Manager', width: 150 }
        ];

        this.EmpcolumnDefs = [
            { headerName: 'S.No.', valueGetter: params => { return params.node.rowIndex + 1 }, width: 80 },
            { headerName: 'Employee Name', field: 'Client_Name', width: 250 },
            { headerName: 'Head Qtr', field: 'HQName', width: 200 },
            { headerName: 'Designation', field: 'ClientTypeDesc', width: 150 },
            { headerName: 'Manager', field: 'Manager', width: 250 }
        ];
        this.EmpcolumnDefsExport = [
            { headerName: 'S.No.', valueGetter: params => { return params.node.rowIndex + 1 }, width: 80 },
            { headerName: 'Employee Name', field: 'Client_Name', width: 400 },
            { headerName: 'Head Qtr', field: 'HQName', width: 200 },
            { headerName: 'Designation', field: 'ClientTypeDesc', width: 150 },
            { headerName: 'Manager', field: 'Manager', width: 150 },
            {
                headerName: 'Status', width: 150
                , valueGetter: params => {
                    var type = "";
                    if (params.data.Leave_Count == 1) {
                        type = 'Leave';
                    } else if (params.data.Logged_Count == 1) {
                        type = 'Logged';
                    } else if (params.data.Logged_Count == 0 && params.data.Leave_Count == 0) {
                        type = 'UnLogged';
                    }
                    return type;
                }
            },
        ];

        this.EmpData = [];
        this.rowData = [];
        this.ManagerList = [];
        this.EmpCountDetails = [
            { "SNo": 1, "LogStatus": "Leave", "LogCount": 0 },
            { "SNo": 2, "LogStatus": "Logged", "LogCount": 0 },
            { "SNo": 3, "LogStatus": "UnLogged", "LogCount": 0 },
        ];
        this.EmpDetailsList = [];
        this.getEmpDetails();
        this.getManagerDetails();
        this.OnLogStatusButtonClick();
        $('#filter-option').trigger('click');
    }

    OnLogStatusButtonClick() {
        var parent = this;
        $(document).ready(function () {
            $('.status-report').click(function (e) {
                parent.EmpData = [];
                if (e.target.id == "Leave") {
                    parent.EmpData = parent.rowData.filter(function (item) { return item.Leave_Count == 1 });
                } else if (e.target.id == "Logged") {
                    parent.EmpData = parent.rowData.filter(function (item) { return item.Logged_Count == 1 });
                } else if (e.target.id == "UnLogged") {
                    parent.EmpData = parent.rowData.filter(function (item) { return item.Logged_Count == 0 && item.Leave_Count == 0 });
                }
            })
        });
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.api.sizeColumnsToFit();
    }

    onGridReady1 = (params) => {
        this.api1 = params.api;
        this.columnApi1 = params.columnApi;
    }

    onGridReady2 = (params) => {
        this.api2 = params.api;
        this.columnApi2 = params.columnApi;
    }
    onFilterTextBoxChanged() {
        this.api1.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }
    onBtnExport() {
        this.api2.exportDataAsCsv({ fileName: 'LoggedUnloggedReport' });
    }

    // getEmpDetails() {
    //     this.http.get('/api/Report/getEmployeeListForLogUnLog')
    //         .subscribe(res => {
    //             this.EmpDetailsList = res;
    //         });
    // }

    getEmpDetails() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
        this.EmpDetailsList = res.data;
        })
    }

    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog',data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }

    OnSearchBtnClick() {
        //this.api.showLoadingOverlay();
        var Date = this.Search_Form.value.SearchDate;
        var Time = this.Search_Form.value.SearchTime;
        //console.log(Date, Time, this.SearchModel.ClientID, this.SearchModel.ManagerID);

        var Data = {
            SearchDate: Date,
            SearchTime: Time,
            ClientID: this.SearchModel.ClientID,
            ManagerID: this.SearchModel.ManagerID,
            status: this.status,
            LoginId: this.token.id,

        }
           console.log(Data);
       this.busy = this.http.post('/api/Report/getLogUnLogReportList', Data)
            .subscribe(res => {
                console.log('res :', res);
                this.rowData = res;
                var LeaveList = this.rowData.filter(function (item) { return item.Leave_Count == 1 });
                var LoggedList = this.rowData.filter(function (item) { return item.Logged_Count == 1 });
                var UnLoggedList = this.rowData.filter(function (item) { return item.Logged_Count == 0 && item.Leave_Count == 0 });
                this.EmpCountDetails[0]["LogCount"] = LeaveList.length;
                this.EmpCountDetails[1]["LogCount"] = LoggedList.length;
                this.EmpCountDetails[2]["LogCount"] = UnLoggedList.length;
                this.api.setRowData(this.EmpCountDetails);
                this.OnLogStatusButtonClick();
            });
    }
}
